import adminMeta from './adminMeta'

export default [
  {
    path: 'settings',
    name: 'SettingsList',
    meta: adminMeta,
    component: () => import('@/views/AdminPanel/Settings/Settings.vue')
  },

  {
    path: 'settings/integration-amocrm',
    name: 'SettingsIntegrationAmoCrm',
    meta: adminMeta,
    component: () => import('@/views/AdminPanel/Settings/SettingsIntegrationAmoCrm'),
    props: true
  }
]
